import { CreateDebitCardInfo } from '@/types/card'

export const formatExternalCardRequestBody = ({
  token,
  owner: {
    first_name: first,
    last_name: last,
    address: { address_1: line1, city, state, postal_code: zipcode },
  },
}: CreateDebitCardInfo) => ({
  token,
  owner: {
    name: {
      first,
      last,
    },
    address: {
      line1,
      city,
      state,
      zipcode,
    },
  },
})
